import React, { useState ,useEffect} from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { withSnackbar } from "./../../../../components/Message/Alert";
import { InputBaseField, TextareaField } from '../../../../components/InputField/InputField';
import { formateMdnNumber, validatePhoneNumber, handleNumberKeyPress } from '../../../../components/Common/Extensions';
import { PostDataAPI } from '../../../../Services/APIService';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { DraggableComponent, Label } from '../../../../components/UiElements/UiElements';
import { ActionDialog } from '../../../../components/ActionDialog/ActionDialog';
import RichTextEditor from 'react-rte';

function OrderNewSIM({ dialogOpenClose, handleClose,handleSuccessClose, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ requestedDate: new Date().toISOString().split('T')[0] });
    const [editorValue, setEditorValue] = useState(RichTextEditor.createValueFromString("", 'html'));

    const [EDITOR_CHAR_LENGTH, setEDITOR_CHAR_LENGTH] = useState(0);

    const regex = /(<([^>]+)>)/ig;
    const regexSpaces = /((&nbsp;))*/gmi;

    const MAX_EDITOR_LENGTH = 10;
    function isEditorEmpty(_editorValue) {
        let editorDetail = _editorValue.toString('html').replace(regex, '');
        let isEmpty = false;
        if (editorDetail.trim() === ""
            || editorDetail.trim().length === 0
            || editorDetail == "<p><br></p>"
            || !!editorDetail.replace(regex, "") == ""
            || !!editorDetail.replace(regexSpaces, '') == ""
            || editorDetail == "<p></p>") {
            isEmpty = true;
        }
        return isEmpty;
    }

    const handleEditorChange = (editorValue) => {

        const editorDetail = editorValue.toString('html').replace(regex, '');

        if (editorDetail && editorDetail.length > (MAX_EDITOR_LENGTH)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: true
            }));
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: false
            }));
        }
        setEDITOR_CHAR_LENGTH(editorDetail.length);

        if (!isEditorEmpty(editorValue))
            errorMessages.errorCustomerNote = false;
        setEditorValue(editorValue);
    }

    const toolbarConfig = {
        // Optionally specify the groups to display (displayed in the order listed).
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
            { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
            { label: 'Italic', style: 'ITALIC' },
            { label: 'Underline', style: 'UNDERLINE' }
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: 'Normal', style: 'unstyled' },
            { label: 'Heading Large', style: 'header-one' },
            { label: 'Heading Medium', style: 'header-two' },
            { label: 'Heading Small', style: 'header-three' }
        ],
        BLOCK_TYPE_BUTTONS: [
            { label: 'UL', style: 'unordered-list-item' },
            { label: 'OL', style: 'ordered-list-item' }
        ]
    };


    const [accountNumber, setAccountNumber] = useState(props.accountNumber);
    const [emailAddress, setEmailAddress] = useState(props.emailAddress);
    const [userName, setUserName] = useState(props.userName);
    const [errorMessages, setErrorMessages] = useState({ errorNotes: false,
        errorEditorMaxValue: false,})
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }
    //action dialog 
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const handleChange = e => {
        const { name, value } = e.target;
        
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    
    const orderNewSIMS = () => {
        ;
        let errorList = [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const requestedDate = new Date(state.requestedDate);
        requestedDate.setHours(0, 0, 0, 0);
        if (!state.noOfSim || parseInt(state.noOfSim) <= 0) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNoOfSim: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNoOfSim: false
            }));
        }

        if (!state.requestedDate) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRequestedDate: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRequestedDate: false
            }));
        }

        if (!state.notes) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNotes: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNotes: false
            }));
        }

        if (requestedDate && requestedDate < today) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRequestedPreviousDate: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRequestedPreviousDate: false
            }));
        }

        if (errorList.length < 1) {
            const request = {
                ...state,
                accountNumber: accountNumber,
                noOfSim: parseInt(state.noOfSim)
            };
            setIsLoading(true)
            PostDataAPI("customer/saveOrderNewSIMRequest", request, true).then((result) => {
                setIsLoading(false)
                if (result.success && result.data != null) {
                    handleSuccessClose("Request sent successfully");
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
            })
        }
        
    }

    useEffect(() => {
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        {/* <FormGroupTitle>Figgers Coverage</FormGroupTitle> */}
                        <Typography className={classes.title}>Order More SIM</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        {/* <span className={classes.crossButton} onClick={handleClose}><img src={CloseIcon} alt="close" /></span> */}
                    </div>
                    
                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <div className={classes.content}>
                        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>
                
                            <Grid container direction="column">
                                <Grid item lg={12}>
                                    <Label title="Number of SIM" size={24} mandatory={true} />
                                </Grid>
                                <Grid item lg={12}>
                                    <Grid item lg={12}>
                                        <InputBaseField
                                            id="noOfSim"
                                            name="noOfSim"
                                            value={state.noOfSim}
                                            type="text"
                                            onChange={handleChange}
                                            placeholder='Number of SIM'
                                            IsDisabled={false}
                                            MaxLength={9}
                                            handleNumberKeyPress={handleNumberKeyPress}
                                        />
                                        {errorMessages.errorNoOfSim && !state.noOfSim ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter number of SIM
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container direction="column">
                                <Grid item lg={12}>
                                    <Label title="Requested Date" size={24} mandatory={true} />
                                </Grid>
                                <Grid item lg={12}>
                                    <Grid item lg={12}>
                                        <InputBaseField
                                            name="requestedDate"
                                            placeholder="Requested Date"
                                            type="date"
                                            value={state.requestedDate}
                                            onChange={handleChange} />
                                        {errorMessages.errorRequestedDate && !state.requestedDate ? (<FormHelperText style={{ color: "red" }} >
                                            Please select requested date
                                        </FormHelperText>) : ('')}
                                        {errorMessages.errorRequestedPreviousDate && state.requestedDate ? (<FormHelperText style={{ color: "red" }} >
                                            The requested date must not be a past date.
                                        </FormHelperText>) : ('')}
                                        
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container direction="column">
                                <Grid item lg={12}>
                                    <Label title="Notes" size={24} mandatory={true} />
                                </Grid>
                                <Grid item lg={12}>
                                    <Grid item lg={12}>
                                    <TextareaField
                                            id="notes"
                                            name="notes"
                                            value={state.notes}
                                            type="text"
                                            onChange={handleChange}
                                            placeholder='Enter Notes'
                                            IsDisabled={false}
                                            MaxLength={5000}
                                            handleNumberKeyPress={handleChange}
                                        />
                                        {/* <RichTextEditor
                                            value={editorValue}
                                            onChange={handleEditorChange}
                                            className={classes.note}
                                            placeholder="Enter Notes"
                                        >
                                        </RichTextEditor>

                                        <div className={classes.DisplayBlock}> {EDITOR_CHAR_LENGTH + '/' + MAX_EDITOR_LENGTH} </div> */}

                                        {errorMessages.errorNotes && !state.notes ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter notes
                                        </FormHelperText>) : ('')}

                                        {errorMessages.errorNotes && state.notes > 5000 ?
                                            (<FormHelperText style={{ color: "red" }} >Maximum 5000 characters allowed</FormHelperText>)
                                            : ('')
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Scrollbars>
                    </div>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            {isLoading ?
                                <Button className={classes.changeBtn}>Order Now</Button>
                                :
                                <Button className={classes.changeBtn}
                                    onClick={orderNewSIMS}>Order Now</Button>
                            }
                            

                        </div>
                    </div>
                </div>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </Dialog >
    )
}
export default withSnackbar(OrderNewSIM);
